import React from 'react';
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  Button,
  Text,
} from '@chakra-ui/react';

const ConfirmDialog = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  title = 'Confirm Action', 
  message = 'Are you sure you want to perform this action?',
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  isLoading = false,
}) => {
  const cancelRef = React.useRef();

  return (
    <AlertDialog
      isOpen={isOpen}
      leastDestructiveRef={cancelRef}
      onClose={onClose}
      isCentered
    >
      <AlertDialogOverlay bg="blackAlpha.700" />
      <AlertDialogContent
        bg="#0a0a0a"
        color="#fafafa"
        border="1px solid rgba(255,255,255,0.10)"
        borderRadius="12px"
        mx={4}
      >
        <AlertDialogHeader
          fontSize="md"
          fontWeight="700"
          letterSpacing="-0.02em"
          color="#fafafa"
          borderBottomWidth="1px"
          borderColor="rgba(255,255,255,0.08)"
          pb={4}
        >
          {title}
        </AlertDialogHeader>

        <AlertDialogBody py={5}>
          <Text fontSize="sm" color="#a3a3a3" lineHeight="1.7">
            {message}
          </Text>
        </AlertDialogBody>

        <AlertDialogFooter
          borderTopWidth="1px"
          borderColor="rgba(255,255,255,0.08)"
          gap={2}
        >
          <Button
            ref={cancelRef}
            onClick={onClose}
            variant="ghost"
            size="sm"
            borderRadius="full"
            color="#a3a3a3"
            fontSize="sm"
            fontWeight="500"
            px={5}
            h="36px"
            _hover={{ color: '#fafafa', bg: 'rgba(255,255,255,0.06)' }}
            _focus={{ boxShadow: 'none' }}
          >
            {cancelText}
          </Button>
          <Button
            onClick={onConfirm}
            size="sm"
            bg="transparent"
            color="rgba(239,68,68,0.8)"
            border="1px solid rgba(239,68,68,0.3)"
            borderRadius="full"
            fontSize="sm"
            fontWeight="500"
            px={5}
            h="36px"
            isLoading={isLoading}
            loadingText="Deleting..."
            _hover={{
              borderColor: 'rgba(239,68,68,0.5)',
              color: 'rgba(239,68,68,1)',
              bg: 'rgba(239,68,68,0.06)',
            }}
            _focus={{ boxShadow: 'none' }}
          >
            {confirmText}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default ConfirmDialog; 